<template>
  <div class="container text-center">
    <div class="col-md-12" style="margin-top: 3em">
      <div class="d-flex justify-content-center flex-wrap">
        <v-card width="400" class="mt-4 me-lg-5">
          <v-card-item>
            <v-card-title>Chat</v-card-title>
            <v-card-subtitle>
              Une réponse à vos questions en un clin d'œil
            </v-card-subtitle>
          </v-card-item>
          <v-card-text class="justify">
            Notre chatbot est à votre disposition. N'hésitez pas à lui poser des
            questions et à discuter avec lui. Il vous répondra et vous indiquera
            des liens vers des documents de référence pour aller plus loin.
          </v-card-text>
        </v-card>

        <v-card width="400" class="mt-4">
          <v-card-item>
            <v-card-title>Science Ouverte</v-card-title>
            <v-card-subtitle>Un chatbot spécialisé</v-card-subtitle>
          </v-card-item>
          <v-card-text class="justify">
            Notre chatbot est spécialiste de science ouverte. Vous pouvez lui
            poser des questions sur des sujets variés tels que les données de la
            recherches, les DMP, les publications, stockage, archivage, et bien
            plus encore.
          </v-card-text>
        </v-card>
      </div>

      <!-- Detailed information section -->
      <v-card class="mt-5 mx-auto" max-width="850">
        <v-card-item>
          <v-card-title>Qu'est-ce que ChatSO ?</v-card-title>
        </v-card-item>
        <v-card-text class="justify">
          <p class="mb-3">
            Le groupe "Outils Applicatifs Communs" des Ateliers de la donnée (Ecosystème Recherche Data Gouv) vous propose ce chatbot d'assistance conçu pour répondre aux questions autour de la science ouverte en France.
          </p>
          <p class="mb-3">
            Grâce à la technologie RAG (Retrieval Augmented Generation), nous avons adapté un grand modèle de langage (LLM) à la documentation spécifique de la science ouverte française.
          </p>
          <p class="mb-3">
            Cette expérimentation est entièrement maîtrisée par le groupe de travail. Ainsi, toutes les données traitées restent locales, et nous suivons une démarche de sobriété énergétique pour limiter l'empreinte carbone de l'outil.
          </p>
        </v-card-text>
      </v-card>

      <v-card class="mt-4 mx-auto" max-width="850">
        <v-card-item>
          <v-card-title>Conditions Générales d'Utilisation</v-card-title>
        </v-card-item>
        <v-card-text class="justify">
          <p class="mb-3">
            L'outil ChatSO est déployé dans le cadre d'une expérimentation. Il a pour objectif d'assister les usagers dans leurs questions liées à la science ouverte en France.
          </p>
          <p class="mb-3">
            L'utilisation de ce service suppose une attitude responsable : il ne doit pas être utilisé de manière nuisible au bon fonctionnement du service, ni pour porter préjudice à des personnes ou entités.
          </p>
          <p class="mb-3">
            En cas de problèmes techniques ou de contenu inapproprié, l'utilisateur s'engage à signaler ces incidents au groupe de travail afin d'améliorer continuellement le service.
          </p>
          <p class="mb-3">
            Veuillez ne pas partager cette initiative avec des tiers n'appartenant pas au périmètre initial de l'expérimentation. Seuls les membres des ateliers de la donnée peuvent obtenir des informations pertinentes.
          </p>
          <p class="mb-3">
            L'expérimentation peut être interrompue ou modifiée à tout moment. Le service peut être indisponible ou évoluer en fonction des besoins et des retours.
          </p>
        </v-card-text>
      </v-card>

      <v-card class="mt-4 mx-auto" max-width="850">
        <v-card-item>
          <v-card-title>Collecte de données</v-card-title>
        </v-card-item>
        <v-card-text class="justify">
          <p class="mb-3">
            Le chatbot collecte des données techniques et anonymes.
          </p>
          <p class="mb-3">
            Les données collectées de type statistiques d'utilisation seront communiquées aux seuls destinataires suivants : administrateurs techniques du site, chefferie de projet et gouvernance de Recherche Data Gouv.
          </p>
          <p class="mb-3">
            Les requêtes faites au chatbot peuvent être monitorées sur un court terme afin de recenser le type de questions le plus fréquent.
          </p>
        </v-card-text>
      </v-card>

      <v-card class="mt-4 mx-auto" max-width="850">
        <v-card-item>
          <v-card-title>Vos droits</v-card-title>
        </v-card-item>
        <v-card-text class="justify">
          <p class="mb-3">
            Le service « ChatSO » étant anonyme, il n'y a pas de traitement de données à caractère personnel permettant d'identifier directement ou indirectement une personne physique. À ce titre, aucune législation protectrice des données à caractère personnel ne s'applique. L'inapplicabilité du Règlement Général sur la Protection des Données « RGPD » ainsi que de la loi du 6 janvier 1978 modifiée dite « Informatique et Libertés » ne permet pas de faire naître de droit pour l'usager.
          </p>
          <p class="mb-3">
            Pour toute question, vous pouvez contacter le groupe de travail <a href="mailto:ateliers-donnee-gt1@groupes.renater.fr">ateliers-donnee-gt1@groupes.renater.fr</a>
          </p>
        </v-card-text>
      </v-card>

      <v-card class="mt-4 mb-5 mx-auto" max-width="850">
        <v-card-item>
          <v-card-title>Fonctionnement de l'outil</v-card-title>
        </v-card-item>
        <v-card-text class="justify">
          <p class="mb-3">
            L'outil s'appuie sur la technologie RAG (Retrieval Augmented Generation), qui permet d'obtenir des réponses adaptées aux principes de la science ouverte en France.
          </p>
          <p class="mb-3">
            Cependant, en raison de la nature probabiliste des modèles d'intelligence artificielle, des hallucinations (réponses erronées ou non fiables) peuvent survenir. Il est donc important de vérifier les informations fournies.
          </p>
          <p class="mb-3">
            ChatSO ne peut bien évidemment pas remplacer l'expertise et les conseils des personnels des ateliers de la donnée ou des centres de référence, il a pour vocation à pouvoir vous donner des informations générales. Chaque situation est spécifique et peut nécessiter un examen attentif. En cas de doutes il est indispensable que vous preniez attache auprès des services compétents.
          </p>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script setup></script>
<style>
.justify {
  text-align: justify;
}
</style>
